import { z } from "zod";

/**
 * Schema for validating email input
 */
export const emailSchema = z.string().min(1, "Email is required").email("Please enter a valid email address");

/**
 * Schema for validating phone number input
 */
export const phoneSchema = z
  .string()
  .min(1, "Phone number is required")
  .regex(/^\+?[0-9]{10,15}$/, "Please enter a valid phone number");

/**
 * Schema for validating email or phone input
 */
export const emailOrPhoneSchema = z
  .string()
  .min(1, "Email or phone number is required")
  .refine(
    (value) => {
      // Check if it's a valid email or phone number
      const isValidEmail = emailSchema.safeParse(value).success;
      const isValidPhone = phoneSchema.safeParse(value).success;
      return isValidEmail || isValidPhone;
    },
    {
      message: "Please enter a valid email address or phone number",
    }
  );

/**
 * Schema for validating login input
 */
export const loginSchema = z.object({
  emailOrPhone: emailOrPhoneSchema,
});

/**
 * Schema for validating password input
 */
export const passwordSchema = z
  .string()
  .min(8, "Password must be at least 8 characters")
  .regex(/[A-Z]/, "Password must contain at least one uppercase letter")
  .regex(/[a-z]/, "Password must contain at least one lowercase letter")
  .regex(/[0-9]/, "Password must contain at least one number");

/**
 * Types derived from the schemas
 */
export type LoginInput = z.infer<typeof loginSchema>;
